import checkout from "./src/views/Checkout";
import appCheckoutAlert from "./src/plugins/appAlert";
import store from "./src/store";

const paygateCheckout = {
  install(Vue, options) {
    Vue.component("checkout", checkout);
    Vue.prototype.$checkout = {
      pay(params) {
        Event.$emit("setCheckoutDialog", params);
      },
    };

    if (options.store) {
      options.store.registerModule("Checkout", store);
    }
  },
};

export default { paygateCheckout, appCheckoutAlert };